import ReactDOM from 'react-dom';

export const getInputValue = component => (component ? ReactDOM.findDOMNode(component).value : null); // eslint-disable-line
